import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { Services } from './components/Services';
import { Market } from './components/Market';
import { Audience } from './components/Audience';
import { Approach } from './components/Approach';
import { ContactForm } from './components/ContactForm';
import { Footer } from './components/Footer';
import { WhatsAppButton } from './components/WhatsAppButton';
export function App() {
  return <div className="min-h-screen flex flex-col w-full" data-id="element-0">
      <Navbar data-id="element-1" />
      <main className="flex-grow" data-id="element-2">
        <Hero data-id="element-3" />
        <Services data-id="element-4" />
        <Market data-id="element-5" />
        <Audience data-id="element-6" />
        <Approach data-id="element-7" />
        <ContactForm data-id="element-8" />
      </main>
      <Footer data-id="element-9" />
      <WhatsAppButton data-id="element-10" />
    </div>;
}